import { Link } from '@tanstack/react-router';
import { Lock } from '@phosphor-icons/react';
import { Icon } from '../Icon';
import { buttonClassName, Button } from '../ui/button';
import { Card } from '../ui/card';
import { useToast } from '../ui/toast';

/** Shown instead of a workspace settings page to anyone who is not an admin (Figma A16.16). */
export function WorkspaceNoAccess() {
  const toast = useToast();
  return (
    <Card padding="lg" className="flex flex-col items-center gap-(--mbm-space-5) py-(--mbm-space-9) text-center">
      <span className="flex size-(--mbm-size-avatar-lg) items-center justify-center rounded-(--mbm-radius-md) bg-surface-tint text-text-primary">
        <Icon icon={Lock} size="lg" />
      </span>
      <div className="flex max-w-(--mbm-layout-dialog-width) flex-col gap-(--mbm-space-2)">
        <h2 className="text-heading-h2 text-text-strong">Only admins can open this page</h2>
        <p className="text-body-medium text-text-secondary">
          Feature flags and other workspace settings are managed by admins. If something needs changing, ask an admin.
        </p>
      </div>
      <div className="flex flex-wrap justify-center gap-(--mbm-space-3)">
        <Link
          to="/subdomain/admin/settings/profile"
          className={buttonClassName({ variant: 'secondary', size: 'compact' })}
        >
          Back to my settings
        </Link>
        {/* TODO: team chat (A14) is not built yet, so this can't open a conversation with an admin. */}
        <Button size="compact" onClick={() => toast({ title: 'Team chat is coming soon', tone: 'info' })}>
          Message an admin
        </Button>
      </div>
    </Card>
  );
}
